// Packages

// Components
import { PageNotComplete } from "../../components/PageNotComplete/PageNotComplete";

// Logic

// Context

// Styles
import "../Page.css";
import "./Events.css";

// Assets

export const Events = () => {
	return (
		<div className='events'>
			<div className='page-top-bar-space'></div>
			<div className='events-front'></div>
			<PageNotComplete />
		</div>
	);
};
